import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useUserSubscription } from '../Account/operation.generated';

/**
 * Hook that provides logic for determining whether the upgrade banner should be rendered.
 */
function useUpgradeBanner(): [boolean, Dispatch<SetStateAction<boolean>>] {
  const { data } = useUserSubscription();

  const isTrial =
    (data?.user?.subscription?.plan?.displayName
      ?.toLowerCase()
      ?.includes('trial') &&
      !data?.user?.subscription?.plan?.displayName
        ?.toLowerCase()
        ?.includes('business')) ??
    false;

  const [showBanner, setShowBanner] = useState<boolean>(isTrial);

  useEffect(() => {
    setShowBanner(isTrial);
  }, [isTrial]);

  // If user context changes, recalculate whether banner should be shown.
  useEffect(() => {
    if (data && data.user.subscription) {
      setShowBanner(isTrial);
    }
  }, [data, setShowBanner, isTrial]);

  return [showBanner, setShowBanner];
}

export default useUpgradeBanner;
